import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ColumnModel } from "@syncfusion/ej2-vue-grids";
import { getCurrentInstance, onBeforeMount, ref } from "vue";
import BaseGridView from "../../common/BaseGridView.Component.vue";
import { SearchOption, TemplateDef } from "../../common/CommonInterfaces";
import { GridConfig } from "../../common/Constants";


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomDimensionComponent',
  setup(__props) {

let columnDef = ref([] as ColumnModel[]);
const _searchOptions = {
  fields: [
    "company.Name",
    "code",
    "createdDateTimeOffset",
    "createdFromImportJournalId",
    "externalImportReference",
    "lastChangedDateTimeOffset",
    "name",
    "ordinal",
  ],
  operator: "contains",
  ignoreCase: true,
} as SearchOption;

const templateDef: TemplateDef = {
  prefix: "customDimension",
  columnNames: ["isActive"],
};

const app = getCurrentInstance();

onBeforeMount(() => {
  assignColumnDef();
});

const assignColumnDef = () => {
  const instance = app?.proxy;
  columnDef.value = [
    {
      field: "companyName",
      headerText: instance?.$t("companyName"),
      textAlign: "Center",

    },
    { field: "code", headerText: instance?.$t("code") },
    {
      field: "createdDateTimeOffset",
      headerText: instance?.$t("createdDate"),
      type: "date",
      format: GridConfig.dateFormat,
    },
    {
      field: "createdFromImportJournalId",
      headerText: instance?.$t("createdFromImportJournalId"),
    },
    {
      field: "externalImportReference",
      headerText: instance?.$t("externalImportReference"),
    },
    {
      field: "isActive",
      headerText: instance?.$t("status"),
      template: "customDimension_isActive",
    },
    {
      field: "lastChangedDateTimeOffset",
      headerText: instance?.$t("lastChangedDate"),
      type: "date",
      format: GridConfig.dateFormat,
    },
    { field: "name", headerText: instance?.$t("name") },
    { field: "ordinal", headerText: instance?.$t("ordinal") },
  ];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseGridView, {
    endpoint: "v1/CustomDimension/GetData",
    pageTitle: _ctx.$t('Custom Dimensions'),
    columnDef: (_unref(columnDef) as Array<ColumnModel>),
    searchOptions: _searchOptions,
    templateDef: templateDef
  }, {
    customDimension_isActive: _withCtx(({ rowData }) => [
      _createElementVNode("span", {
        class: _normalizeClass(rowData.value ? 'badge badge-success' : 'badge badge-danger')
      }, _toDisplayString(rowData.value ? "Active" : "Inactive"), 3)
    ]),
    _: 1
  }, 8, ["pageTitle", "columnDef"]))
}
}

})